import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { platformSubscriptionService } from "../../Api/Services/platformSubscriptionService";
import Button, { buttonClasses } from "../Button/Button";

const PLANS_URL = "https://essaecommerce.com/planos";

const ManageSubscriptionCard = () => {
  const [canManage, setCanManage] = useState(false);
  const [canSubscribeAgain, setCanSubscribeAgain] = useState(false);
  const [isOpening, setIsOpening] = useState(false);

  useEffect(() => {
    platformSubscriptionService.getStatus()
      .then((status) => {
        setCanManage(status.canManageSubscription);
        setCanSubscribeAgain(status.canSubscribeAgain);
      })
      .catch(() => setCanManage(false));
  }, []);

  const handleOpen = async () => {
    try {
      setIsOpening(true);
      window.location.href = await platformSubscriptionService.createPortal();
    } catch {
      toast.error("Não foi possível abrir a assinatura. Tente novamente.");
      setIsOpening(false);
    }
  };

  if (!canManage) {
    return null;
  }

  return (
    <div className="mt-auto bg-white border border-gray-200 rounded-xl p-4 shadow-sm flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div>
        <h2 className="font-semibold text-gray-800">{"Assinatura da plataforma"}</h2>
        <p className="text-sm text-gray-500">
          {canSubscribeAgain
            ? "Sua assinatura foi cancelada. Veja as faturas ou assine novamente com o mesmo e-mail."
            : "Veja as faturas, atualize o cartão ou cancele a assinatura."}
        </p>
      </div>
      <div className="shrink-0 flex flex-col sm:flex-row gap-2">
        <Button isLoading={isOpening} variant="secondary"
          type="button"
          onClick={() => void handleOpen()}
          disabled={isOpening}
          className="text-sm px-4 py-2"
        >
          {"Gerenciar assinatura"}
        </Button>
        {canSubscribeAgain && (
          <a href={PLANS_URL} className={buttonClasses("primary", "text-sm px-4 py-2 text-center")}>
            {"Assinar novamente"}
          </a>
        )}
      </div>
    </div>
  );
};

export default ManageSubscriptionCard;
